import common from '../common';
import Actor from '../physics/Actor';
import THREEParticleEmitter from '../particles/THREEParticleEmitter';

export default class GemTile extends THREE.Group {
	constructor() {
		super();

		this._type 			= Actor.TILE;
		this._animSystem 	= null;
		this._clip 			= null;
		this._action 		= null;
		this._playing 		= false;
		this._gem 			= null;
		this.claimed 		= false;
		this._particles 	= null;

		this.tweens = new P3.utils.TWEEN.Group();

		this.yPosition = 1.2;

		this.init();
	}

	init() {
		const base = common.assets.model('tile_001');
		const matCopy = new THREE.MeshBasicMaterial({
			map: common.assets.texture(common.levelSettings.floortexture)
		});

		base.material = matCopy;
		this.add(base);

		const gemObj = common.assets.anim('omnitrix');

		this._gem = gemObj.scene;
		this._clip = gemObj.animations[0];
		this._animSystem = new THREE.AnimationMixer(this._gem);
		this._action = this._animSystem.clipAction(this._clip);
		this.add(this._gem);

		const scale = 0.5;

		this._gem.position.y = this.yPosition;
		this._gem.scale.set(scale, scale, scale);

		this._particles = new THREEParticleEmitter(P3.assets.json('particle_3d_coin_collect_burst'), false);
		this._particles.position.y = this.yPosition + 1;
		this.add(this._particles);
		common.particles3D.push(this._particles);

		P3.utils.delay(P3.math.random(0.5, 2), () => {
			this._action.play();
		});
	}

	destroy() {
		console.warn('No dispose method implemented for GemTile');
		this._particles.dispose();
	}

	update() {
		this._animSystem.update(P3.Ticker.dt * this._animSystem.timeScale);
		this.tweens.update();
	}

	startAnim() {
		this._action.play();
	}

	stopAnim() {
		this._action.stop();
	}

	claim() {
		if (this.claimed) {
			return;
		}

		this.claimed = true;

		this._particles.playDuration(0.1, false);

		P3.audio.playSound('sfx_code_token_pickup_00');

		new P3.utils.TWEEN.Tween(this._gem.position, this.tweens)
			.to({
				y: '+2'
			}, 500)
			.easing(P3.utils.Easing.Back2.Out)
			.onComplete(() => {
				this._gem.visible = false;
			})
			.start();

		new P3.utils.TWEEN.Tween(this._gem.scale, this.tweens)
			.to({x: 0.1, y: 0.1, z: 0.1}, 500)
			.easing(P3.utils.TWEEN.Easing.Quadratic.Out)
			.start();
	}

	reset() {
		this.tweens.removeAll();

		this.claimed = false;
		this._gem.visible = true;
		this._gem.position.y = this.yPosition;
		this._gem.scale.setScalar(0.5);
	}

	playOnce() {
		if (this._playing) {
			return;
		}
		this._playing = true;
		this._action.setLoop(THREE.LoopOnce, 1);
		this._action.play();

		P3.utils.delay(this._clip.duration, () => {
			this._action.setLoop(THREE.LoopRepeat, Infinity);
			this._action.stop();
			this._playing = false;
		}, this);
	}

	get activated() {
		return this._activated;
	}

	get type() {
		return this._type;
	}

	get trapType() {
		return this._trapType;
	}

	set activated(v) {
		this._activated = v;
	}

	set type(v) {
		this._type = v;
	}

	get gem() {
		return this._gem;
	}

	set gem(v) {
		this._gem = v;
	}
}
